//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingDocumentController_create,
  Response$AdminBillingDocumentController_create$Status$201,
  ResponseContentType$AdminBillingDocumentController_create,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingDocumentController_create = () =>
  useApiClientMutation<
    Params$AdminBillingDocumentController_create,
    Response$AdminBillingDocumentController_create$Status$201[ResponseContentType$AdminBillingDocumentController_create]
  >({ method: 'AdminBillingDocumentController_create' });
